module.exports = "<div class=\"py-4 account-activation\" ng-if=$ctrl.loading><p class=\"subtitle text-center\">Account Activation...</p><div class=account-activation__spinner><gmc-local-spinner></gmc-local-spinner></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/states/auth/components/account-activation/account-activation.component.html
// module id = 954
// module chunks = 31